import { FC } from "react";
import { Link } from "react-router-dom";
import EyeIcon from "src/components/ui-icons/reports/EyeIcon";
import GraphicIcon from "src/components/ui-icons/reports/GraphicIcon";
import GroupIcon from "src/components/ui-icons/reports/GroupIcon";
import ListIcon from "src/components/ui-icons/reports/ListIcon";
import NotificationsIcon from "src/components/ui-icons/reports/NotificationsIcon";
import StarIcon from "src/components/ui-icons/reports/StarIcon";
import WorkPlaceIcon from "src/components/ui-icons/reports/WorkPlace";
import { FileIcon } from "src/components/ui-icons/upload";
import { SettingsList } from "src/types/main";

const reportPagePath = "/dashboard/1/reports/";

const reportsList: SettingsList = [
  {
    title: "Реестр документов",
    icon: <FileIcon />,
    description: "Посмотреть реестр документов",
    path: `${reportPagePath}1`,
  },
  {
    title: "Календарь OWD",
    icon: <StarIcon />,
    description: "Посмотреть календарь OWD",
    path: `${reportPagePath}2`,
  },
  {
    title: "Отчет по ознакомлению",
    icon: <EyeIcon />,
    description: "Посмотреть отчеты по ознакомлению",
    path: `${reportPagePath}3`,
  },
  {
    title: "Реестр уведомлений",
    icon: <NotificationsIcon />,
    description: "Посмотреть реестр уведомлений",
    path: `${reportPagePath}4`,
  },
  {
    title: "Отчеты по сотрудникам",
    icon: <GroupIcon />,
    description: "Посмотреть отчеты по сотрудникам",
    path: `${reportPagePath}5`,
  },
  {
    title: "Общий отчет",
    icon: <GraphicIcon />,
    description: "Посмотреть общий отчет",
    path: `${reportPagePath}6`,
  },
  {
    title: "Реестр шаблонов тестов",
    icon: <ListIcon />,
    description: "Посмотреть реестр шаблонов тестов",
    path: `${reportPagePath}7`,
  },
  {
    title: "Отчет ознакомлений по рабочим местам",
    icon: <WorkPlaceIcon />,
    description: "Посмотреть отчет ознакомлений по рабочим местам",
    path: `${reportPagePath}8`,
  },
];

interface IProps {
  addSetCrumbs: (crumbs: string) => void;
}

const ReportsCards: FC<IProps> = ({ addSetCrumbs }) => {
  return (
    <div>
      <div className="grid grid-cols-3 py-5 px-7.5 gap-5">
        {reportsList.map((report) => (
          <div key={report.path}>
            <Link
              to={report.path}
              onClick={() => {
                addSetCrumbs(report.title);
              }}
              title={report.description}
              className="bg-white shadow-custom py-[60px] flex rounded-md justify-center gap-2 font-medium hover:text-darkblue"
            >
              {report.icon}
              {report.title}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsCards;
